import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const urlsPublicas = ['/auth/login', '/register'];
  const backendApiEndpoint = normalizeBaseUrl(environment.apiEndpoint);

  // Verifica si la URL es pública
  const esUrlPublica = urlsPublicas.some((url) => req.url.includes(url));
  const esBackendApi = isBackendApiRequest(req.url, backendApiEndpoint);

  // Si es pública, no añade token
  if (esUrlPublica) {
    return next(req);
  }

  if (!esBackendApi) {
    return next(req);
  }

  const token = authService.getToken();
  if (token) {
    const requestConToken = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!environment.production) {
      console.log(' Token añadido a:', req.url);
    }

    return next(requestConToken);
  }

  return next(req);
};

function normalizeBaseUrl(url: string): string {
  const value = String(url || '').trim();
  if (!value) return '/';
  return value.endsWith('/') ? value : `${value}/`;
}

function isBackendApiRequest(url: string, backendApiEndpoint: string): boolean {
  return url.startsWith(backendApiEndpoint) || url.includes('/api/');
}
